import React from 'react';
import { Container } from 'react-bootstrap';
import { useSelectTenancyResources } from '../hooks/use-tenancy';
import { AnyType } from '../interfaces';
import { getConfigurationDataKey, rawCleanHtmlProps } from '../utils';

interface LoginBannerProps {
  contentKey?: string;
}

/**
 * Renders a tenant configurable announcement banner above the login hero image.
 * Nothing is rendered unless the tenant configures the `login.banner` resource.
 */
export const LoginBanner = ({ contentKey = 'login.banner' }: LoginBannerProps) => {
  const banner = useSelectTenancyResources(getConfigurationDataKey(contentKey)) as AnyType;
  const content = `${banner?.content ?? ''}`.trim();

  if (!content) return null;

  return (
    <Container fluid className='login-banner' data-testid='cmx__login__banner'>
      <div className='login-banner-content' {...rawCleanHtmlProps(content)} />
    </Container>
  );
};
